/** Status of a prompt being recorded for a given voice. */
export enum WorkflowPromptVoiceStatus {
  /** TTS voice that finished. */
  autoGenerated = 'AUTO_GENERATED',
  /** Prompt/version/voice not found. */
  notFound = 'NOT_FOUND',
  /** Static prompt recorded by a person. */
  recorded = 'RECORDED',
  /** Submitted, but not yet saved. */
  submitted = 'SUBMITTED',
  /** Dynamic prompt with the static parts recorded by a person. */
  ttpRecorded = 'TTP_RECORDED'
}
